'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _translate = require('../../language/translate');

var _commonFunctions = require('../../helpers/commonFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Validates the values in the Get Quote portion of the form (the first page).
 * @param {Object} values - The values in the form to validate.
 * @returns {Object} Object of errors found in the form.
 */
exports.default = function (values, props) {
  return {
    applicant: values.applicant.map(function (applicant, i) {
      return {
        dob: !applicant.dob,
        first_name: !applicant.first_name,
        last_name: !applicant.last_name,
        email: i === 0 && !applicant.email,
        additional_data: {
          relationship_to_primary_applicant: i > 0 && !applicant.additional_data.relationship_to_primary_applicant
        }
      };
    }),
    application: {
      effective_date: !values.application.effective_date && (0, _translate.t)('Effective Date is required'),
      expiry_date: function () {
        if (!values.application.expiry_date) {
          return (0, _translate.t)('Expiry Date is required');
        }

        var expiryDate = (0, _moment2.default)(values.application.expiry_date);
        if (expiryDate.isSame(values.application.effective_date, 'day') || expiryDate.isBefore(values.application.effective_date, 'day')) {
          return (0, _translate.t)('Expiry date not set properly.');
        }

        return null;
      }(),
      additional_data: {
        eligibility: !values.application.additional_data.eligibility,
        policy_type: !values.application.additional_data.policy_type && (0, _translate.t)('Policy Type is required'),
        country_of_origin: !values.application.additional_data.country_of_origin,
        destination_province: !(0, _commonFunctions.getCountryStatesProvinces)().CA.includes(values.application.additional_data.destination_province) && (0, _translate.t)('Destination Province is required')
      }
    },
    errors: props.application.quote.information && Array.isArray(props.application.quote.information)
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/rimi_is/Quote.js
// module id = 1777
// module chunks = 0